<template>
  <div id="app">
    <!-- <Header /> -->
    <router-view @openRegModal="openRegModal" @openEditInfoModal="openEditInfoModal" :is_show="isShow"/>
    <div v-show="$route.name != 'sku-price'" class="side-btn" :class="showUp ? 'bottom-80' : 'bottom-130'">
    	<a href="http://wpa.qq.com/msgrd?v=3&uin=1591541919&site=www.5yoho.cn&menu=yes" target="_blank" title="QQ:1591541919">
        <i class="iconfont icon-qq"></i>
      </a>
      <a v-if="showUp" href="javascript:;" title="回顶部" @click="gotoTop">
        <i class="iconfont icon-up"></i>
      </a>
    </div>
    <PageLoading :show="loading" />
    <modal-login
    		style="border-bottom:none;"
	      v-show="isModalRegVisible"
	      :backdrop="true"
	      class="modal-login"
	      @close="closeRegModal"
	    >
	      <template slot="header">
	      	<h2 v-if="isShowSidModal">{{isSid ? '当前供应商已完善信息，请登录后继续操作' : '为了方便经销商与您取得联系，请完善信息'}}</h2>
	        <h2 v-else>{{formType == 1 ? '注册供应商账号' : '供应商账号登录'}}</h2>
	      </template>
	      <template slot="body">
	      	<div v-if="isShowSidModal">
	      		<div v-if="isSid" class="login-type">
	      			<a href="javascript:;" :class="loginMobile ? 'active':''" @click="changeLoginType('mobile')">手机登录</a>
	      			<a href="javascript:;" :class="loginUser ? 'active':''" @click="changeLoginType('user')">用户名登录</a>
	      		</div>
	      		<div
		          class="ipt-group"
		        >
		          <label for="iptCN">公司名称：</label>
		          <span v-if="!isNotMe">{{supplierInfo.name}}</span>
		          <input v-if="isNotMe"
		            type="text"
		            id="iptCN"
		            v-model.trim="iptName"
		          >
		          <a v-if="!isNotMe" href="javascript:;" class="tx-ifno tx-underline notme-btn" @click="notMe()">这不是我</a>
		        </div>
		        <div class="ipt-group" v-if="loginUser && isSid">
		          <label for="iptUName">用户名：</label>
		          <input
		            type="text"
		            id="iptUName"
		            v-model.trim="iptUName"
		          >
		        </div>
		        <div class="ipt-group" v-if="loginUser && isSid">
		          <label for="iptPassW">密码：</label>
		          <input
		            type="text"
		            id="iptPassW"
		            v-model.trim="iptPassW"
		          >
		        </div>
		        <div
		          class="ipt-group"
		          v-if="!isSid"
		        >
		          <label for="iptWW">联系人旺旺：</label>
		          <input
		            type="text"
		            id="iptWW"
		            v-model.trim="iptWang"
		          >
		        </div>
		        <div class="ipt-group" v-if="!isSid || loginMobile">
		          <label for="iptUN">联系人手机：</label>
		          <input
		            type="text"
		            id="iptUN"
		            v-model.trim="iptUserName"
		            placeholder="将作为您的登录用户名"
		            v-if="!isSid"
		          >
		          <span v-else>{{supplierInfo.mobile}}</span>
		        </div>
		        <div class="ipt-group" v-if="!isSid || loginMobile">
		          <label for="iptCD">验证码：</label>
		          <input
		            type="text"
		            id="iptCD"
		            v-model.trim="iptCode"
		            @keyup.enter="regAndgotoPriceList"
		          >
		          <span>
		          	<span v-if="isSid">
			          	<a v-if="!isSidSendAgain" href="javascript:;" class="code-btn" @click="getCode()">获取验证码</a>
			          	<span class="send-code" v-else>{{isSidTime+'秒后重新获取'}}</span>
			          </span>
			          <span v-else>
			          	<a v-if="!sidSendAgain" href="javascript:;" class="code-btn" @click="getCode()">获取验证码</a>
			          	<span class="send-code" v-else>{{sidTime+'秒后重新获取'}}</span>
			          </span>
		          </span>
		        </div>
	      	</div>
	      	<div v-else>
	      		<div
		          v-if="formType == 1"
		          class="ipt-group"
		        >
		          <label for="iptCN">公司名称：</label>
		          <input
		            type="text"
		            id="iptCN"
		            v-model.trim="iptName"
		          >
		        </div>
		        <div
		          v-if="formType == 1"
		          class="ipt-group"
		        >
		          <label for="iptCT">联系人：</label>
		          <input
		            type="text"
		            id="iptCT"
		            v-model.trim="iptContact"
		          >
		        </div>
		        <div
		          v-if="formType == 1"
		          class="ipt-group"
		        >
		          <label for="iptWW">旺旺：</label>
		          <input
		            type="text"
		            id="iptWW"
		            v-model.trim="iptWang"
		          >
		        </div>
		        <div class="ipt-group">
		          <label for="iptUN">{{formType == 1 ? '手机号' : '用户名'}}：</label>
		          <input
		            type="text"
		            id="iptUN"
		            v-model.trim="iptUserName"
		            :placeholder="formType == 1 ? '手机号将作为您的登录用户名' : ''"
		          >
		        </div>
		        <div class="ipt-group">
		          <label for="iptCD">验证码：</label>
		          <input
		            type="text"
		            id="iptCD"
		            v-model.trim="iptCode"
		            @keyup.enter="regAndgotoPriceList"
		          >
		          <span v-if="formType == 1">
		          	<a v-if="!loginSendAgain" href="javascript:;" class="code-btn" @click="getCode()">获取验证码</a>
		          	<span class="send-code" v-else>{{loginTime+'秒后重新获取'}}</span>
		          </span>
		          <span v-if="formType == 2">
		          	<a v-if="!registerSendAgain" href="javascript:;" class="code-btn" @click="getCode()">获取验证码</a>
		          	<span class="send-code" v-else>{{registerTime+'秒后重新获取'}}</span>
		          </span>
		        </div>
	      	</div>
	        
	      </template>
	      <template slot="footer">
	      	<div v-if="isShowSidModal">
	      		<a
	          class="btn btn-primary"
	          href="javascript:;"
	          @click="regAndgotoPriceList()"
	        >{{isSid ? '立即登录' : '保存信息'}}</a>
	        <a v-if="isSid"
	          class="go-login"
	          :href="`http://wpa.qq.com/msgrd?v=3&amp;uin=1846438979&amp;site=www.5yoho.cn&amp;menu=yes`"
	          target="_blank"
	        >收不到验证码？ 联系客服</a>
	        <a v-if="!isSid"
	          class="go-login"
	          href="javascript:;"
	          @click="editInfo"
	        >稍后完善信息</a>
	      	</div>
	        <div v-else="">
	        	<a
	          class="btn btn-primary"
	          href="javascript:;"
	          @click="regAndgotoPriceList()"
	        >{{formType == 1 ? '立即注册' : '立即登录'}}</a>
	        <a
	          class="go-login"
	          href="javascript:;"
	          @click="changeFromType()"
	        >{{formType == 1 ? '已有账号？ 立即登录' : '没有账号，立即注册'}}</a>
	        </div>
	      </template>
    </modal-login>
		<ModalVerChange v-show="isVerModalVisible"></ModalVerChange>
  </div>
</template>

<script>
import modal from "./components/modal.vue";
import PageLoading from "./components/pageLoading";
import ModalVerChange from "./components/modal-ver-change-alert"; //提醒版本更新
export default {
  data(){
    return {
      showUp: false,
      isModalRegVisible: false,
    	formType: 1,
	  	iptName: localStorage.getItem("supplierPriceInfo") && JSON.parse(localStorage.getItem("supplierPriceInfo")).name ? JSON.parse(localStorage.getItem("supplierPriceInfo")).name :"",
	  	iptUserName: localStorage.getItem("supplierPriceInfo") && JSON.parse(localStorage.getItem("supplierPriceInfo")).mobile ? JSON.parse(localStorage.getItem("supplierPriceInfo")).mobile :"",
	  	iptContact: localStorage.getItem("supplierPriceInfo") && JSON.parse(localStorage.getItem("supplierPriceInfo")).contact ? JSON.parse(localStorage.getItem("supplierPriceInfo")).contact :"",
	  	iptWang: localStorage.getItem("supplierPriceInfo") && JSON.parse(localStorage.getItem("supplierPriceInfo")).wangwang ? JSON.parse(localStorage.getItem("supplierPriceInfo")).wangwang :"",
	  	iptCode: "",
	  	iptUName: "",
	  	iptPassW: "",
	  	loginTime:0,
      loginSendAgain:false,
      registerTime:0,
      registerSendAgain:false,
      loading: false,
			isShowSidModal:localStorage.getItem("supplierPriceInfo") 
						&& JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId!=""
			      && JSON.parse(localStorage.getItem("supplierPriceInfo")).fromUrl
			      ? true : false,//是否通过地址栏信息登录
			isSid:localStorage.getItem("supplierPriceInfo") 
      			&& JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId!=""
			      && JSON.parse(localStorage.getItem("supplierPriceInfo")).mobile!=""
			      ? true : false,//地址栏信息是否注册
			supplierInfo:JSON.parse(localStorage.getItem("supplierPriceInfo"))?JSON.parse(localStorage.getItem("supplierPriceInfo")):"",
			isSidTime:0,
      isSidSendAgain:false,
      sidTime:0,
      sidSendAgain:false,
      isShow:localStorage.getItem("supplierPriceInfo") 
      			&& JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId!=""
			      && JSON.parse(localStorage.getItem("supplierPriceInfo")).mobile==""
			      && localStorage.getItem("alertEditInfo")
			      ? true : false,
			loginMobile:false,
			loginUser:false,
			isNotMe:false,
			supplierPriceInfoArr:[],
			isVerModalVisible:false
    }
  },
  components: {
  	PageLoading,
		ModalVerChange,
    "modal-login":modal,
  },
  watch: {
  	isModalRegVisible: function() {
      this.sendAuthCodeCount();
//    this.formType = 1;
      this.iptCode = "";
      if(this.$route.name == 'pageOfferHis'){
      	this.formType = 2;
      }else{
      	this.formType = 1;
      }
      this.supplierInfo = JSON.parse(localStorage.getItem("supplierPriceInfo"));
      this.iptUserName = this.supplierInfo ? this.supplierInfo.mobile :"";
      this.iptName = this.supplierInfo ? this.supplierInfo.name :"";
      this.iptContact = this.supplierInfo ? this.supplierInfo.contact :"";
	  	this.iptWang = this.supplierInfo ? this.supplierInfo.wangwang :"";
	  	this.iptUName = this.supplierInfo ? this.supplierInfo.mobile :"";
	  	this.loginMobile= /^1[3-9]\d{9}$/.test(this.iptUName);
	  	this.loginUser= !/^1[3-9]\d{9}$/.test(this.iptUserName);
	  	this.isNotMe = false;
    },
  },
  mounted() {
//	window.addEventListener("storage", (e) => {
//				if(localStorage.getItem('supplierPriceInfo')){
//  		this.isShowSidModal = localStorage.getItem("supplierPriceInfo") 
//					&& JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId!=""
//		      && JSON.parse(localStorage.getItem("supplierPriceInfo")).fromUrl
//		      ? true : false;
//		      this.isSid = localStorage.getItem("supplierPriceInfo") 
//			&& JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId!=""
//		      && JSON.parse(localStorage.getItem("supplierPriceInfo")).mobile!=""
//		      ? true : false;
//		      this.supplierInfo = JSON.parse(localStorage.getItem("supplierPriceInfo"));
//  	}
//  });
  },
  methods: {
  	notMe(){
  		if(this.isSid){
  			this.isModalRegVisible = false;
  			this.isModalRegVisible = true;
  			this.formType = 1;
  			this.isShowSidModal = false;
  			this.isSid = false;
  			localStorage.setItem("alertEditInfonotMe",true);
  		}else{
  			this.isNotMe = true;
  			this.iptName = this.supplierInfo.name;
  		}
  	},
  	changeLoginType(type){
  		if(type == "user"){
  			this.loginMobile = false;
  			this.loginUser = true;
  		}else{
  			this.loginUser = false;
  			this.loginMobile = true;
  		}
  	},
  	editInfo(){
  		if(!this.isSid){
  			this.isModalRegVisible = false;
  			localStorage.setItem("alertEditInfo",true);
  			this.isShow = localStorage.getItem("supplierPriceInfo") 
      			&& JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId!=""
			      && JSON.parse(localStorage.getItem("supplierPriceInfo")).mobile==""
			      && localStorage.getItem("alertEditInfo")
			      ? true : false;
  		}
  	},
    gotoTop(){
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    regAndgotoPriceList() {
      //注册并继续报价
      // 验证
      if(!this.isShowSidModal){
      	if (!this.iptName && this.formType == 1) {
	        //公司名
	        this.$toasted.show(
	          `<i class="iconfont icon-warning"></i> 公司名称必须输入`,
	          {
	            theme: "primary",
	            position: "top-center",
	            className: "danger",
	            duration: 3000
	          }
	        );
	        document.getElementById("iptCN").focus();
	        return;
	      }
	      if (!this.iptContact && this.formType == 1) {
	        //密码
	        this.$toasted.show(
	          `<i class="iconfont icon-warning"></i> 联系人必须输入`,
	          {
	            theme: "primary",
	            position: "top-center",
	            className: "danger",
	            duration: 3000
	          }
	        );
	        document.getElementById("iptCT").focus();
	        return;
	      }
	      if (!this.iptWang && this.formType == 1) {
	        //密码
	        this.$toasted.show(
	          `<i class="iconfont icon-warning"></i> 旺旺必须输入`,
	          {
	            theme: "primary",
	            position: "top-center",
	            className: "danger",
	            duration: 3000
	          }
	        );
	        document.getElementById("iptWW").focus();
	        return;
	      }
	      if (
	        !this.iptUserName ||
	        (!/^1[3-9]\d{9}$/.test(this.iptUserName) && this.formType == 1)
	      ) {
	        //用户名注册
	        this.$toasted.show(
	          `<i class="iconfont icon-warning"></i> 请正确填写手机号码，手机号将作为登录账户使用`,
	          {
	            theme: "primary",
	            position: "top-center",
	            className: "danger",
	            duration: 3000
	          }
	        );
	        document.getElementById("iptUN").focus();
	        return;
	      }
	      if (!this.iptUserName && this.formType == 2) {
	        //用户名登录
	        this.$toasted.show(
	          `<i class="iconfont icon-warning"></i> 用户名必须输入`,
	          {
	            theme: "primary",
	            position: "top-center",
	            className: "danger",
	            duration: 3000
	          }
	        );
	        document.getElementById("iptUN").focus();
	        return;
	      }
	      if (!this.iptCode) {
	        //密码
	        this.$toasted.show(
	          `<i class="iconfont icon-warning"></i> 验证码必须输入`,
	          {
	            theme: "primary",
	            position: "top-center",
	            className: "danger",
	            duration: 3000
	          }
	        );
	        document.getElementById("iptCD").focus();
	        return;
	      }
      }else{
      	if(!this.isSid){
		      if(this.isNotMe && !this.iptName){
	  				this.$toasted.show(
			          `<i class="iconfont icon-warning"></i> 公司名称必须输入`,
			          {
			            theme: "primary",
			            position: "top-center",
			            className: "danger",
			            duration: 3000
			          }
			        );
			        document.getElementById("iptCN").focus();
			        return;
	  			}
      		if (!this.iptWang) {
		        //密码
		        this.$toasted.show(
		          `<i class="iconfont icon-warning"></i> 旺旺必须输入`,
		          {
		            theme: "primary",
		            position: "top-center",
		            className: "danger",
		            duration: 3000
		          }
		        );
		        document.getElementById("iptWW").focus();
		        return;
		      }
	      	if (
		        !this.iptUserName ||
		        (!/^1[3-9]\d{9}$/.test(this.iptUserName))
		      ) {
		        //用户名注册
		        this.$toasted.show(
		          `<i class="iconfont icon-warning"></i> 请正确填写手机号码，手机号将作为登录账户使用`,
		          {
		            theme: "primary",
		            position: "top-center",
		            className: "danger",
		            duration: 3000
		          }
		        );
		        document.getElementById("iptUN").focus();
		        return;
		      }
		      if (!this.iptCode) {
		        //密码
		        this.$toasted.show(
		          `<i class="iconfont icon-warning"></i> 验证码必须输入`,
		          {
		            theme: "primary",
		            position: "top-center",
		            className: "danger",
		            duration: 3000
		          }
		        );
		        document.getElementById("iptCD").focus();
		        return;
		      }
      	}else{
      		if(this.loginMobile){
      			if (!this.iptCode) {
			        //密码
			        this.$toasted.show(
			          `<i class="iconfont icon-warning"></i> 验证码必须输入`,
			          {
			            theme: "primary",
			            position: "top-center",
			            className: "danger",
			            duration: 3000
			          }
			        );
			        document.getElementById("iptCD").focus();
			        return;
			      }
      		}else{
      			if (!this.iptUName) {
			        //密码
			        this.$toasted.show(
			          `<i class="iconfont icon-warning"></i> 用户名必须输入`,
			          {
			            theme: "primary",
			            position: "top-center",
			            className: "danger",
			            duration: 3000
			          }
			        );
			        document.getElementById("iptUName").focus();
			        return;
			      }
      			if (!this.iptPassW) {
			        //密码
			        this.$toasted.show(
			          `<i class="iconfont icon-warning"></i> 密码必须输入`,
			          {
			            theme: "primary",
			            position: "top-center",
			            className: "danger",
			            duration: 3000
			          }
			        );
			        document.getElementById("iptPassW").focus();
			        return;
			      }
      		}
      	}
      }
      
      let params1 = {
      	name:this.iptName,
		contact:this.iptContact,
		wangwang:this.iptWang,
		mobile:this.iptUserName,
		token:this.iptCode,
		isNotMe:this.isNotMe,
      };
      let params2 = {
		mobile:this.iptUserName,
		token:this.iptCode,
      };
      let params3 = {
      	username:this.iptUName,
		password:this.iptPassW,
      }
      let callUrl;
      let params;
      let tx;
      if(!this.isShowSidModal){
      	callUrl = this.formType == 1 ? "api.OfferProduct.register" : "api.OfferProduct.login";
      	params = this.formType == 1 ? params1 : params2;
      	tx = this.formType == 1 ? "注册成功" : "登录成功";
      }else{
      	callUrl = !this.isSid ? "api.OfferProduct.register" : "api.OfferProduct.login";
      	params1.supplierId = JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId;
//    	params = !this.isSid ? params1 : params2;
      	tx = !this.isSid ? "注册成功" : "登录成功";
      	if(!this.isSid){
      		params = params1;
      	}else{
      		if(this.loginMobile){
      			params = params2;
      		}else{
      			params = params3;
      		}
      	}
      }
//    console.log(params)
//    return;
      this.loading = true;
      this.$apiCall(callUrl, params, r => {
        this.loading = false;
        if (r.data.ErrorCode == "9999") {
          //成功获取登录信息
          let data = r.data.Data.Results;
          localStorage.setItem("supplierPriceInfo",JSON.stringify(data));
          localStorage.setItem("supplierPriceInfoLogin",r.data.Data.Results.supplierId);
          this.$toasted.show(
            `<i class="iconfont icon-warning"></i> ${tx}`,
            {
              theme: "primary",
              position: "top-center",
              className: "success",
              duration: 3000
            }
          );
          this.isModalRegVisible = false;
          localStorage.removeItem("alertEditInfo");
          if(this.$route.name == 'pageOfferHis'){
		      	window.location.reload();
		      }
          if(this.supplierPriceInfoArr.length>0){
          	this.autoSubmitOffer(this.supplierPriceInfoArr);
          }
        } else {
          this.$toasted.show(
            `<i class="iconfont icon-warning"></i> ${r.data.Message}`,
            {
              theme: "primary",
              position: "top-center",
              className: "danger",
              duration: 3000
            }
          );
        }
      });
    },
    autoSubmitOffer(arr){
			let param = {
				supplierId: JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId,
				products: arr,
			}
			this.loading = true;
			this.$apiCall("api.OfferProduct.genDetail", param, r => {
  		this.loading = false;
        if (r.data.ErrorCode == '9999') {
        	this.$toasted.show(
	            `<i class="iconfont icon-warning"></i> 提交报价成功`,
	            {
	              theme: "primary",
	              position: "top-center",
	              className: "success",
	              duration: 3000
	            }
	        );
        	localStorage.removeItem("canSupplyIdArrs");
        	this.$router.push({ name: 'pageOfferHis' });
        } else {
	        this.$toasted.show(
	            `<i class="iconfont icon-warning"></i> ${r.data.Message}`,
	            {
	              theme: "primary",
	              position: "top-center",
	              className: "danger",
	              duration: 3000
	            }
	        );
	    	}
			});
    },
    getCode(){
    		if(this.iptUserName && (/^1[345789]\d{9}$/.test(this.iptUserName))){
    			this.loading = true;
	        	this.$apiCall("api.OfferProduct.sendToken", {
		       	 	mobile: this.iptUserName
		      	}, r => {
		      		this.loading = false;
			        if (r.data.ErrorCode == '9999') {
			        	this.$toasted.show(
				            `<i class="iconfont icon-warning"></i> 发送验证码成功`,
				            {
				              theme: "primary",
				              position: "top-center",
				              className: "success",
				              duration: 3000
				            }
				        );
				        if(this.isShowSidModal){
				        	if(this.isSid){
				        		sessionStorage.setItem('isSidTime', this.$moment().unix());
					        	this.isSidTime = 120;
					        	this.isSidSendAgain = true;
				          		let interval = window.setInterval(()=> {
						          	if ((this.isSidTime--) <= 0) {
							            this.isSidTime = 0;
							            this.isSidSendAgain = false;
							            window.clearInterval(interval); //停止
						          	}
					        	}, 1000);
				        	}else{
				        		sessionStorage.setItem('sidTime', this.$moment().unix());
					        	this.sidTime = 120;
					        	this.sidSendAgain = true;
				          		let interval = window.setInterval(()=> {
						          	if ((this.sidTime--) <= 0) {
							            this.sidTime = 0;
							            this.sidSendAgain = false;
							            window.clearInterval(interval); //停止
						          	}
					        	}, 1000);
				        	}
				        }else{
				        	if(this.formType == 1){
					        	sessionStorage.setItem('sendLoginTime', this.$moment().unix());
					        	this.loginTime = 120;
					        	this.loginSendAgain = true;
				          		let interval = window.setInterval(()=> {
						          	if ((this.loginTime--) <= 0) {
							            this.loginTime = 0;
							            this.loginSendAgain = false;
							            window.clearInterval(interval); //停止
						          	}
					        	}, 1000);
					        }else{
					        	sessionStorage.setItem('sendRegisterTime', this.$moment().unix());
					        	this.registerTime = 120;
					        	this.registerSendAgain = true;
				          		let interval = window.setInterval(()=> {
						          	if ((this.registerTime--) <= 0) {
							            this.registerTime = 0;
							            this.registerSendAgain = false;
							            window.clearInterval(interval); //停止
						          	}
					        	}, 1000);
					        }
				        }
			        } else {
				        this.$toasted.show(
				            `<i class="iconfont icon-warning"></i> ${r.data.Message}`,
				            {
				              theme: "primary",
				              position: "top-center",
				              className: "danger",
				              duration: 3000
				            }
				        );
				    }
		    	});
			}else{
				let failTx = this.formType == 1 ? "请正确填写手机号码，手机号将作为登录账户使用" : "请正确填写手机号码";
				this.$toasted.show(
		            `<i class="iconfont icon-warning"></i> ${failTx}`,
		            {
		              theme: "primary",
		              position: "top-center",
		              className: "danger",
		              duration: 3000
		            }
		        );
			}
    },
  	sendAuthCodeCount(){
  		let vm = this;
  		let nowTime = this.$moment().unix();
  		if(sessionStorage.getItem('sendRegisterTime') && this.formType == 2){
  			if(nowTime - sessionStorage.getItem('sendRegisterTime')>=120){
	  					this.registerTime = 0;
		          this.registerSendAgain = false;
	            sessionStorage.removeItem("sendRegisterTime");
	  		}else{
	  				this.registerSendAgain = true;
	        	this.registerTime = (parseFloat(sessionStorage.getItem('sendRegisterTime'))+120) - parseFloat(nowTime);
	        	let interval = window.setInterval(()=> {
		          	if ((this.registerTime--) <= 0) {
			            this.registerTime = 0;
			            this.registerSendAgain = false;
			            window.clearInterval(interval); //停止
		          	}
		        }, 1000);
	  		}
  		}
  		if(sessionStorage.getItem('sendLoginTime') && this.formType == 1){
  			if(nowTime - sessionStorage.getItem('sendLoginTime')>=120){
	  					this.loginTime = 0;
		          this.loginSendAgain = false;
	            sessionStorage.removeItem("sendLoginTime");
	  		}else{
	  				this.loginSendAgain = true;
	        	this.loginTime = (parseFloat(sessionStorage.getItem('sendLoginTime'))+120) - parseFloat(nowTime);
	        	let interval = window.setInterval(()=> {
		          	if ((this.loginTime--) <= 0) {
			            this.loginTime = 0;
			            this.loginSendAgain = false;
			            window.clearInterval(interval); //停止
		          	}
		        }, 1000);
	  		}
  		}
  	},
  	openRegModal(type,arr) {
  		this.supplierPriceInfoArr = [];
  		if(arr) this.supplierPriceInfoArr = arr;
  		if(localStorage.getItem("supplierPriceInfo") && JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId){
  				this.isShowSidModal = localStorage.getItem("supplierPriceInfo") 
																&& JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId!=""
													      && JSON.parse(localStorage.getItem("supplierPriceInfo")).fromUrl
													      ? true : false;
		      this.isSid = localStorage.getItem("supplierPriceInfo") 
							  				&& JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId!=""
									      && JSON.parse(localStorage.getItem("supplierPriceInfo")).mobile!=""
									      ? true : false;
		      this.supplierInfo = JSON.parse(localStorage.getItem("supplierPriceInfo"));
		      
	  			if(JSON.parse(localStorage.getItem("supplierPriceInfo")).fromUrl && !localStorage.getItem("alertEditInfo")){
	  				this.isModalRegVisible = true;
	  			}else{
	  				if(!localStorage.getItem("supplierPriceInfoLogin")){
			      	this.isModalRegVisible = true;
			      }else{
			      	this.$router.push({ name: 'pageOfferHis' });
			      }
	  			}
  		}else{
  			//打开登录框重置
//    		this.iptName = this.iptUserName = this.iptContact = this.iptWang = this.iptCode = "";
      		this.isModalRegVisible = true;
  		}
    },
    openEditInfoModal(){
    	this.isModalRegVisible = true;
    },
    closeRegModal() {
      this.isModalRegVisible = false;
      if(!this.isSid){
  			this.isModalRegVisible = false;
  			localStorage.setItem("alertEditInfo",true);
  			this.isShow = localStorage.getItem("supplierPriceInfo") 
      			&& JSON.parse(localStorage.getItem("supplierPriceInfo")).supplierId!=""
			      && JSON.parse(localStorage.getItem("supplierPriceInfo")).mobile==""
			      && localStorage.getItem("alertEditInfo")
			      ? true : false;
  		}
    },
    changeFromType() {
      this.formType = this.formType == 1 ? 2 : 1;
    },
  },
  mounted(){
    window.addEventListener("scroll", e=> {
      let scrollT = document.documentElement.scrollTop || document.body.scrollTop;
      this.showUp = scrollT > 50;
    })
  }
};
</script>

<style lang="less" scoped>
@import "./assets/style/config.less";
.side-btn{
  position: fixed;
  right: 2px;
  bottom: 80px;
  a{
		display: block;
		margin-bottom: 10px;
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background-color: @white;
    border: 1px solid @b-c-gray;
    color: @gray;
    i{
      font-size: 22px;
    }
  }
  a:hover{
    color: @primary;
  }
}
.side-btn.bottom-130{
	bottom: 124px;
}
.code-btn{
	color: @primary;
	text-decoration: underline;
	font-size: 14px;
}
.send-code{
	color: @gray-1;
	text-decoration: underline;
	font-size: 14px;
}
*:not(input,textarea) {
   -webkit-touch-callout: none!important;
   -webkit-user-select: none!important;
   user-select: none!important;
}
.modal-header {
    border-bottom: none!important;
}
.login-type{
	margin: -1.25rem -2rem 1.25rem;
	height: 38px;
	border-bottom: 1px solid #ddd;
	padding: 0;
	line-height: 38px;
	display: flex;
	align-items: center;
	position: relative;
	>a{
		flex-grow: 1;
		text-align: center;
		height: 38px;
		line-height: 38px;
		color: #666;
		font-size: 14px;
	}
	>a.active{
		color: @primary;
		font-weight: bold;
	}
}
.login-type:before {
    content: "";
    width: 1px;
    height: 30px;
    background: #ddd;
    position: absolute;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}
.notme-btn{
	color: @primary;
	margin-left: 10px;
	text-decoration: underline;
	font-size: 14px;
}
</style>